<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00393 2.10938C8.71268 2.10938 8.47656 2.34549 8.47656 2.63674C8.47656 2.92799 8.71268 3.16411 9.00393 3.16411C10.749 3.16411 12.1687 4.58357 12.1687 6.32831C12.1687 6.61956 12.4048 6.85568 12.696 6.85568C12.9873 6.85568 13.2234 6.61956 13.2234 6.32831C13.2234 4.00199 11.3306 2.10938 9.00393 2.10938Z"
      :fill="color"
    />
    <path
      d="M7.64057 0.14127C5.25792 0.63914 3.326 2.55257 2.81765 4.95002C2.38841 6.97447 2.91736 9.00695 4.26886 10.5263C4.92951 11.2689 5.30837 12.2492 5.30837 13.2186V14.2733C5.30837 14.9751 5.76778 15.5712 6.40154 15.7777C6.60995 17.0091 7.67875 18 8.99994 18C10.3208 18 11.3899 17.0094 11.5984 15.7777C12.2321 15.5712 12.6915 14.9751 12.6915 14.2733V13.2185C12.6915 12.2473 13.0716 11.2788 13.7618 10.4914C14.772 9.33891 15.3284 7.86017 15.3284 6.32764C15.3284 2.33494 11.6737 -0.701322 7.64057 0.14127ZM8.99994 16.9453C8.32203 16.9453 7.72765 16.4788 7.50816 15.8519H10.4917C10.2722 16.4788 9.67786 16.9453 8.99994 16.9453ZM11.6368 14.2733C11.6368 14.5641 11.4002 14.8007 11.1094 14.8007H6.89047C6.59968 14.8007 6.36311 14.5641 6.36311 14.2733V13.7459H11.6368V14.2733ZM12.9686 9.7962C12.2331 10.6353 11.7806 11.6472 11.6658 12.6912H6.33421C6.21952 11.6466 5.76817 10.6248 5.05699 9.82528C3.93061 8.55904 3.49047 6.86179 3.84946 5.1688C4.26851 3.19244 5.87874 1.58696 7.85633 1.17375C11.2323 0.468238 14.2736 3.00354 14.2736 6.32764C14.2736 7.60429 13.8102 8.83611 12.9686 9.7962Z"
      :fill="color"
    />
    <path
      d="M1.5821 6.32617H0.527367C0.23612 6.32617 0 6.56229 0 6.85354C0 7.14479 0.23612 7.38091 0.527367 7.38091H1.5821C1.87335 7.38091 2.10947 7.14479 2.10947 6.85354C2.10947 6.56229 1.87335 6.32617 1.5821 6.32617Z"
      :fill="color"
    />
    <path
      d="M1.80232 3.68933L1.05652 2.94353C0.850599 2.73757 0.51667 2.73757 0.310716 2.94353C0.104761 3.14948 0.104761 3.48338 0.310716 3.68933L1.05652 4.43513C1.26244 4.64109 1.59637 4.64112 1.80232 4.43513C2.00828 4.22918 2.00828 3.89529 1.80232 3.68933Z"
      :fill="color"
    />
    <path
      d="M1.80232 9.27361C1.59637 9.06765 1.26244 9.06765 1.05652 9.27361L0.310716 10.0194C0.104761 10.2254 0.104761 10.5593 0.310716 10.7652C0.516635 10.9712 0.850564 10.9712 1.05652 10.7652L1.80232 10.0194C2.00828 9.81345 2.00828 9.47956 1.80232 9.27361Z"
      :fill="color"
    />
    <path
      d="M17.4727 6.32617H16.418C16.1267 6.32617 15.8906 6.56229 15.8906 6.85354C15.8906 7.14479 16.1267 7.38091 16.418 7.38091H17.4727C17.764 7.38091 18.0001 7.14479 18.0001 6.85354C18.0001 6.56229 17.764 6.32617 17.4727 6.32617Z"
      :fill="color"
    />
    <path
      d="M17.6929 2.94353C17.487 2.73757 17.1531 2.73757 16.9471 2.94353L16.2013 3.68933C15.9954 3.89529 15.9954 4.22918 16.2013 4.43513C16.4073 4.64105 16.7412 4.64109 16.9471 4.43513L17.6929 3.68933C17.8989 3.48338 17.8989 3.14948 17.6929 2.94353Z"
      :fill="color"
    />
    <path
      d="M17.6929 10.0194L16.9471 9.27361C16.7412 9.06765 16.4073 9.06765 16.2013 9.27361C15.9954 9.47956 15.9954 9.81345 16.2013 10.0194L16.9471 10.7652C17.1531 10.9711 17.487 10.9712 17.6929 10.7652C17.8989 10.5593 17.8989 10.2254 17.6929 10.0194Z"
      :fill="color"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  color: {
    type: String,
    default: "black",
  },
});
</script>
